"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const formik_1 = require("formik");
const yup = __importStar(require("yup"));
const components_1 = require("@/store/ducks/components");
const selectors_1 = require("@/store/ducks/components/selectors");
const updateComponentUseCase_1 = __importDefault(require("@/useCases/components/updateComponentUseCase"));
const index_view_1 = __importDefault(require("../index.view"));
function AddComponentsModal() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const isModalVisible = (0, react_redux_1.useSelector)(selectors_1.isEditComponentModalVisibleSelector);
    const componentToBeEdited = (0, react_redux_1.useSelector)(selectors_1.componentToBeEditedSelector);
    const isLoading = (0, react_redux_1.useSelector)(selectors_1.isSavingChangesSelector);
    const onCloseModal = react_1.default.useCallback(() => {
        dispatch((0, components_1.closeEditComponentModal)());
    }, []);
    const initialValues = {
        name: componentToBeEdited?.name,
        unit: componentToBeEdited?.unit,
        analysis: componentToBeEdited?.analysis,
        formula: componentToBeEdited?.formula,
        isRequiredOnModels: false,
        order: componentToBeEdited?.order
    };
    const validationSchema = yup.object().shape({
        name: yup.string().required("Name is required"),
        unit: yup.string().required("Unit is required"),
        analysis: yup.string(),
        formula: yup.string(),
    });
    const onSubmit = (values) => {
        (0, updateComponentUseCase_1.default)(componentToBeEdited?.id, values)(dispatch);
    };
    return (react_1.default.createElement(formik_1.Formik, { initialValues: initialValues, enableReinitialize: true, validationSchema: validationSchema, onSubmit: onSubmit }, (props) => {
        return (react_1.default.createElement(index_view_1.default, { formTitle: "Edit Component", onBlur: props.handleBlur, values: props.values, confirmActionText: "Edit Component", onSubmit: props.handleSubmit, errors: props.errors, touched: props.touched, isLoading: isLoading, onChange: props.handleChange, onClose: onCloseModal, isOpen: isModalVisible }));
    }));
}
exports.default = AddComponentsModal;
